import { RefundStatus } from './RefundStatus';

export interface Refund {
  id: number;
  userFirstName: string;
  userLastName: string;
  email: string;
  productName: string;
  optionName?: string;
  quantity: number;
  reason: number;
  status: RefundStatus;
  createdAt: Date;
  updatedAt: Date;
}

export const refundFromResponse = (responseData: any): Refund => ({
  id: responseData.id,
  userFirstName: responseData.user_first_name,
  userLastName: responseData.user_last_name,
  email: responseData.email,
  productName: responseData.product_name,
  optionName: responseData.option_name,
  quantity: responseData.quantity,
  reason: responseData.reason,
  status: responseData.status,
  createdAt: new Date(responseData.created_at),
  updatedAt: new Date(responseData.updated_at),
});
